<!--
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-05-25 19:05:44
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-04-25 18:24:22
 * @FilePath: \jyrg-web\src\components\pc\Layout\Layout.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="content-v">
    <Header></Header>
    <router-view></router-view>

    <VoucherIndexCenter
      style="z-index: 99999"
      :show="recordVisbile"
      @close="closeVoucher(false)"
    ></VoucherIndexCenter>

    <RecordDialog
      style="z-index: 99999"
      :show="recordVisbile"
      @close="close(false)"
    ></RecordDialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Header from "../Header/index.vue";

import RecordDialog from "../../public/recordDialog/index.vue";
import VoucherIndexCenter from "../../../components/public/VoucherIndexCenter";//充值弹框

export default {
  computed: {
    ...mapGetters({ topUpShow: "base/topUpShow" }),
    recordVisbile() {
      return this.$store.state.user.recordDialogVisible;
    },
  },
  components: { Header,  RecordDialog,VoucherIndexCenter },
  methods: {
    ...mapMutations({
      recordDialogVisible: "user/recordDialogVisible",
    }),
    close(visible) {
      this.recordDialogVisible(visible);
    },
  },
};
</script>
<style lang="scss" scoped>
.content-v {
  position: absolute;
  min-width: 1920px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // overflow: auto;
  z-index: 1;
}
</style>
